import type { CommunityDetail } from '@pba/react-network';
import { type ReactNode, useMemo } from 'react';
import { EarthLineIcon, LockLineIcon, MailLineIcon } from 'ui';

export type PrivacyInformation = {
  description: string;
  icon: ReactNode;
  name: string;
};

type P = {
  privacy: CommunityDetail['privacy'];
};

export const useGetCommunityPrivacyInformation = ({ privacy }: P): PrivacyInformation =>
  useMemo(() => {
    switch (privacy) {
      case 'private':
        return { description: 'Members must request to join', icon: <LockLineIcon />, name: 'Private' };
      case 'public':
        return { description: 'Any member can join', icon: <EarthLineIcon />, name: 'Public' };
      case 'secret':
        return { description: 'Member must be invited to be able to join', icon: <MailLineIcon />, name: 'Secret' };
    }
  }, [privacy]);
